import type React from 'react';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost';
};

export default function Button({ variant = 'primary', className = '', ...props }: ButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 active:scale-95';
  const variants: Record<string, string> = {
    primary: 'text-white bg-[#5B3FD0] hover:bg-[#4729b0] shadow-md hover:shadow-lg',
    secondary: 'text-[#5B3FD0] bg-[#5B3FD0]/5 hover:bg-[#5B3FD0]/10 border border-[#5B3FD0]/20',
    ghost: 'text-[#5B3FD0] bg-transparent hover:bg-[#5B3FD0]/5',
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props} />
  );
}
